const isSpaceManagmentPageRegex = '^/(?:hosted/)?places/admin(?:/space-management)?/?$';

export function isSpaceManagementPage(pathname: string): boolean {
    const homepageRegex = new RegExp(
        isSpaceManagmentPageRegex,
        'i' /* Flag for case insensitive */
    );
    return (pathname.match(homepageRegex) || []).length > 0;
}
